import { lazy } from 'react'
import useQueryParams from 'hooks/useQueryParams';
const Catalog = lazy(() => import('./containers/catalog'));
const Home = lazy(() => import('./containers/Home'));

const HomePageContentRenderer = () => {
    const params = useQueryParams();
    return params?.["catalog"] ? <Catalog /> : <Home />
}

export default HomePageContentRenderer